const rootFontSize = '16px'
const fontSizes = {
    small: '0.75rem',
    p: '1rem',
    h6: '0.875rem',
    h5: '1rem',
    h4: '1.25rem',
    h3: '1.375rem',
    h2: '1.5rem',
    h1: '1.675rem',
    h0: '2.5rem',
}
const fontFamily = {
    title: "'Jost',sans-serif",
    paragraph: "'Montserrat', sans-serif",
}
export default { rootFontSize, fontSizes, fontFamily }
